<template>
    <div class="front-box">
        <div class="overflow-hidden">
            <FrontLogo />
            
            <h5 class="text-center">{{ $t('recover_password') }}</h5>
            <div class="body">
                <form v-on:submit.prevent="validateRecover">
                    <ValidationObserver ref="formPassword">
                        <ValidationProvider :rules="rules.newp" name="vpNew" v-slot="{ valid, validated }" vid="vidnewp">
                            <div class="form-group">
                                <label>{{ $t('new_password') }}:</label>
                                <div class="position-relative" :class="{'error-asterisk': !valid && validated}">
                                    <mmPassword :configPatron="configPatron" v-model="recover.Password" nombre="newpassword"></mmPassword>
                                </div>
                            </div>
                        </ValidationProvider>
                        <ValidationProvider :rules="rules.repeat" name="vpRepeat" v-slot="{ errors, valid, validated }">
                            <div class="form-group" :class="{'error': !valid && validated}">
                                <label>{{ $t('confirm_password') }}:</label>
                                <div :class="{'valid': valid}">
                                    <input :type="type" class="form-control" v-model="recover.Password2" @keyup="keyup" :placeholder="$t('insert_new_password')" tabindex="2">
                                    <a href="#" class="show-pass border-0 bg-transparent" :style="{ right: errors.length ? '24px' : '3px' }" @click.prevent="showPassword">
                                        <svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false">
                                            <path opacity=".3" d="M12 6a9.77 9.77 0 00-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5A9.77 9.77 0 0012 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"></path>
                                            <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13a9.77 9.77 0 01-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5A9.77 9.77 0 0112 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
                                            <line v-show="type == 'text'" x1="3" y1="3" x2="21" y2="21" />
                                        </svg>
                                    </a>
                                </div>
                                <span class="displayError">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                        <ValidationProvider :rules="rules.question" name="vpQuestion" v-slot="{ errors, valid, validated }" v-if="this.$Params.recover=='1' || this.$Params.recover=='3'">
                            <div class="form-group" :class="{'error': !valid && validated}">
                                <label>Pregunta de seguridad:</label>
                                <div :class="{'valid': valid}">
                                    <textarea class="form-control" v-model="recover.Question" tabindex="3"></textarea>
                                </div>
                                <span class="displayError">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                        <ValidationProvider :rules="rules.question" name="vpResponse" v-slot="{ errors, valid, validated }" v-if="this.$Params.recover=='1' || this.$Params.recover=='3'">
                            <div class="form-group" :class="{'error': !valid && validated}">
                                <label>Respuesta a la pregunta:</label>
                                <div :class="{'valid': valid}">
                                    <input type="text" class="form-control" v-model="recover.Response" tabindex="4">
                                </div>
                                <span class="displayError">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </ValidationObserver>
                
                    <mmButton :text="$t('generate_password')" :click="validateRecover" classe="btn btn-primary btn-block font-16"></mmButton>
                    <a href="#" @click.prevent="$emit('hideMessage');$router.push('/')">Entrar al portal</a>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import mmPassword from '@/components/common/mmPassword.vue';
    import mmButton from '@mysummar/summar-vue/src/components/mmButton.vue';
    import FrontLogo from '@/views/layout/Front-logo.vue';
    import { userService } from '@/api/user';
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    import { rules } from "@/_helpers/validations/validate-password";
    import { cookie } from '@/_utils/cookie'
    export default {
        name: 'Recover',
        props: ['token'],
        data() {
            return {
                rules,
                configPatron: {},
                recover: {
                    Password: '',
                    Password2: '',
                    Question: '',
                    Response: ''
                },
                type: 'password',
                logoImage: `${this.$Params.urlImages}logo`,
                styleWrapper: {
                    'background-image': 'url(\'' + this.$Params.urlImages + 'background\')'
                }
            }
        },
        components: {
            mmPassword,
            mmButton,
            FrontLogo,
            ValidationObserver,
            ValidationProvider
        },
        methods: {
            showPassword() {
				this.type = this.type === 'password' ? 'text' : 'password';
			},
            async validateRecover() {
                let valid = await this.$refs.formPassword.validate();
                if(valid) {
                    if(await userService.validateRecover(this.recover)) {
                        this.$emit('updateMessage',this.$i18n.t('password_changed'), 'success', 1200);
                        this.$router.push('/');
                    }
                }
            },
            keyup() {
                this.$emit('hideMessage');
            }
        },
        async created() {
            let patron = await userService.getPasswordPattern();
            this.configPatron = patron;
            //se guarda el token para que la llamada a la api incluya el token
            cookie.setToken(this.token);
        }
    }

</script>
<style>
.show-pass {
		position: absolute;
		right: 22px;
		top: 6px;
		opacity: .7;
		z-index: 10;
	}
.show-pass:hover {
		opacity: 1;
	}
.show-pass path { fill:#97a6ba; }
.show-pass line { stroke:#97a6ba; stroke-width: 3px; }
</style>